<template>
  <div>
    <PromotionHeader :img_header="header_image" header="แก้ไขโปรโมชั่น" link_back="stock/promotion_stock/promotionset"/>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-form ref="edit" @submit.prevent="save_edit">
        <v-card elevation="6" class="pa-2">
          <div class="grid_half">
            <div class="pa-2">
              <div class="mt-4">
                <v-img height="200" width="200" max-width="200" v-if="header_list.promotion_image === null" :lazy-src="img_holder" :src="default_img" class="preview mx-auto"></v-img>
                <v-img height="200" width="200" max-width="200" v-if="header_list.promotion_image !== null" :lazy-src="img_holder" :src="header_list.promotion_image" class="preview mx-auto"></v-img>
              </div>
              <div class="ml-3 mr-3">
                <v-file-input color="#86bc3a" accept="image/*" label="รูปภาพสินค้า" prepend-icon="mdi-camera" hide-details="auto" v-model="pro_pic_name" @change="onFileChange"></v-file-input>
              </div>
            </div>
            <div class="grid_list">
              <div class="ma-3 mr-3">
                <v-text-field color="#86bc3a" label="ชื่อโปรโมชั่น" v-model="header_list.promotion_name" hide-details="auto" required outlined></v-text-field>
              </div>
              <div class="ma-3 mr-3">
                <v-text-field color="#86bc3a" label="ราคาขาย(ต่อชุด)" @keypress="onlyCurrency($event, header_list.price_per_set)" v-model="header_list.price_per_set" hide-details="auto" required outlined></v-text-field>
              </div>
              <div class="ml-3 mt-3 mr-3">
                <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false" :return-value.sync="date" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable color="#86bc3a" v-model="date" label="วันที่สิ้นสุดโปรโมชั่น (วัน/เดือน/ปี)" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" outlined></v-text-field>
                  </template>
                  <v-date-picker locale="TH" color="#86bc3a" @change="diffDate_TH(dateEN)" v-model="dateEN" :min="start_date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="selectDate()">
                      ตกลง
                    </v-btn>
                    <v-btn text color="primary" @click="menu_date = false">
                      ยกเลิก
                    </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>
              <div class="ma-6 mr-1">
                <div class="d-flex">
                  <div class="mr-2">จำนวนคงเหลือ</div>
                  <div>{{ format_number(header_list.quantity) }}</div>
                  <div class="ml-2">ชุด</div>
                </div>
              </div>
              <div class="ml-3 mr-3">
                <v-select color="#86bc3a" :items="promotion_list" item-text="show_promotion_name" item-value="show_promotion_id" :rules="[v => !!v || 'กรุณาเลือกสถานะแสดงการขาย']" v-model="header_list.show_promotion" label="สถานะแสดงการขาย" hide-details="auto" required outlined/>
              </div>
            </div>
          </div>
          <div class="pa-2">
            <v-card-title>
              <div>
                สินค้าในชุด
              </div>
            </v-card-title>
            <v-data-table :headers="headers" :items="data_list" :search="search" mobile-breakpoint="0" hide-default-footer>
              <template v-slot:item="dataDetail">
                <tr>
                  <td>{{ dataDetail.item.product_name }}</td>
                  <td>{{ dataDetail.item.lot_no }}</td>
                  <td>{{ dataDetail.item.date_expired }}</td>
                  <td>{{ format_price(dataDetail.item.cost) }}</td>
                  <td class="text-center">{{ format_number(dataDetail.item.quantity_per_sell) }}</td>
                </tr>
              </template>
              <template v-slot:body.append>
                <tr>
                  <td colspan="3" class="text-center">รวมราคาต้นทุนของชุด</td>
                  <td>{{ format_price(total_cost) }}</td>
                  <td class="text-center">{{ format_number(total_set) }}</td>
                </tr>
              </template>
            </v-data-table>
            <v-divider/>
            <div  v-if="date_raw > date_now" class="pl-6 pt-6 pr-6">
              <usercreate_promotion :user="header_list.user_name" :create_time="header_list.created_at" :status="header_list.status"/>
            </div>
            <div v-else class="pl-6 pt-6 pr-6">
              <usercreate_promotion :user="header_list.user_name" :create_time="header_list.created_at" :status="0"/>
            </div>
          </div>
          <div class="text-center mt-4 pb-4">
            <v-btn height="45" class="white--text grad-success-bg btn_size" type="submit">บันทึกข้อมูล</v-btn>
          </div>
        </v-card>
      </v-form>
    </div>
  </div>
</template>

<script>
import PromotionHeader from "@/components/admin/stock/storage_promotion/header_promotion/PromotionHeader";
import usercreate_promotion from "@/components/admin/stock/storage_promotion/header_promotion/usercreate_promotion";
import {HTTP} from "@/axios";
import {diffDateTH, formatNumber, formatPrice, minDate, onlyForCurrency} from "@/js/handler";
import Swal from "sweetalert2";
import HeaderImage from "@/assets/boxes_set.png";
import img_holder from "@/assets/pharmacy.png";
export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Promotion_set_edit",
  components: {
    usercreate_promotion,
    PromotionHeader
  },
  data() {
    return {
      loading_page: false,
      header_image: HeaderImage,
      img_holder: img_holder,
      default_img: null,
      search: null,
      pro_pic_name: null,
      menu_date: false,
      date: '',
      date_raw: '',
      dateEN: '',
      date_now: null,
      start_date: this.min_date(),
      select_1: null,
      headers: [
        {
          text: 'ชื่อสินค้า',
          value: 'product_name',
          fixed: true,
          width: '250px',
        },
        {
          text: 'ล็อตสินค้า',
          value: 'lot_no',
          fixed: true,
          width: '150px',
        },
        {
          text: 'วันหมดอายุ',
          value: 'date_expired',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ราคาทุน',
          value: 'cost',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวนในชุด',
          value: 'quantity_per_sell',
          fixed: true,
          align: 'center',
          width: '150px',
        },
      ],
      promotion_list: [
        {
          show_promotion_id: '1',
          show_promotion_name: 'แสดงทั้งขายปลีก , ขายส่ง',
        },
        {
          show_promotion_id: '2',
          show_promotion_name: 'แสดงเฉพาะขายปลีก',
        },
        {
          show_promotion_id: '3',
          show_promotion_name: 'แสดงเฉพาะขายส่ง',
        },
      ],
      header_list: [],
      data_list: [],
    }
  },
  methods: {
    get_date() {
      let date_today = new Date();
      let day = date_today.getDay();
      let month = date_today.getMonth() + 1;
      let year = date_today.getFullYear();
      if (month < 10){
        month = '0'+ month
      }
      if (day < 10){
        day = '0'+ day
      }
      this.date_now = year + '-' + month + '-' + day
    },
    onFileChange(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall ="png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.header_list.promotion_image = null
            this.pro_pic_name = null
          })
        }else {
          if (file) {
            this.header_list.promotion_image = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.header_list.promotion_image = null
            this.pro_pic_name = null
          }
        }
      } else {
        this.header_list.promotion_image = null
        this.pro_pic_name = null
      }
    },
    min_date: function () {
      return minDate()
    },
    format_number: function (value) {
      return formatNumber(value)
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    onlyCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    diffTH: function (value) {
      return diffDateTH(value)
    },
    async selectDate() {
      this.$refs.menu_date.save(this.date)
      this.menu_date = false
    },
    diffDate_TH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const total_date = day+'-'+month+'-'+year
      return this.date = total_date
    },
    diffDateEN() {
      const diff = this.date.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year+'-'+month+'-'+day
    },
    get_data() {
      this.loading_page = true
      HTTP.post('/inventory/promotions/mains/get', {
        id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.header_list = res.data.head
          this.default_img = res.data.head.promotion_image
          if (res.data.head.end_date !== null) {
            this.date_raw = res.data.head.end_date
            this.date = res.data.head.end_date
            this.diffDate_TH(this.date)
          }
          else {
            this.date = ''
          }
          this.data_list = res.data.lists
        }
      })
    },
    save_edit() {
      if (this.$refs.edit.validate()) {
        if (this.pro_pic_name !== null) {
          let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
          let file = this.pro_pic_name.name;
          let ext = file.split('.').pop().toLowerCase();
          if (parseInt(extall.indexOf(ext)) < 0) {
            Swal.fire({
              text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then(() => {
              this.imagePreviewURL = null
              this.pro_pic_name = null
            })
          }
          else {
            Swal.fire({
              title: 'ต้องการบันทึกการแก้ไขหรือไม่ ?',
              icon: 'warning',
              showDenyButton: true,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            }).then((res) => {
              if (res.isConfirmed === true) {
                let config = {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
                let formData = new FormData()
                formData.append('promotion_image', this.pro_pic_name, this.pro_pic_name.name)
                formData.append('user_id', this.$store.state.userDetail.id)
                formData.append('user_name', this.$store.state.userDetail.name)
                formData.append('id', this.$route.params.id)
                formData.append('promotion_name', this.header_list.promotion_name)
                formData.append('show_promotion', this.header_list.show_promotion)
                formData.append('end_date', this.diffDateEN())
                formData.append('price_per_set', this.header_list.price_per_set)
                HTTP.post('/inventory/promotions/mains/update', formData, config)
                    .then((res) => {
                  if (res.data.success === true) {
                    Swal.fire({
                      title: 'แก้ไขข้อมูลสำเร็จ !',
                      icon: 'success',
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: `ตกลง`,
                      denyButtonText: `ยกเลิก`,
                    }).then((res) => {
                      if (res.isConfirmed === true) {
                        this.$router.push('/stock/promotion_stock/promotionset')
                      }
                      else {
                        this.$router.push('/stock/promotion_stock/promotionset')
                      }
                    })
                  }
                })
              }
            })
          }
        }
        else {
          Swal.fire({
            title: 'ต้องการบันทึกการแก้ไขหรือไม่ ?',
            icon: 'warning',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then((res) => {
            if (res.isConfirmed === true) {
              let config = {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
              let formData = new FormData()
              formData.append('user_id', this.$store.state.userDetail.id)
              formData.append('user_name', this.$store.state.userDetail.name)
              formData.append('id', this.$route.params.id)
              formData.append('promotion_name', this.header_list.promotion_name)
              formData.append('show_promotion', this.header_list.show_promotion)
              formData.append('end_date', this.diffDateEN())
              formData.append('price_per_set', this.header_list.price_per_set)
              HTTP.post('/inventory/promotions/mains/update', formData, config)
                  .then((res) => {
                    if (res.data.success === true) {
                      Swal.fire({
                        title: 'แก้ไขข้อมูลสำเร็จ !',
                        icon: 'success',
                        showDenyButton: false,
                        showCancelButton: false,
                        confirmButtonText: `ตกลง`,
                        denyButtonText: `ยกเลิก`,
                      }).then((res) => {
                        if (res.isConfirmed === true) {
                          this.$router.push('/stock/promotion_stock/promotionset')
                        }
                        else {
                          this.$router.push('/stock/promotion_stock/promotionset')
                        }
                      })
                    }
                  })
            }
          })
        }
      }
      else {
        Swal.fire({
          title: 'กรุณาตรวจสอบข้อมูล !',
          text: 'ยังไม่ได้เลือกสินค้าหรือล็อตสินค้าหรือและจำนวนในชุดเป็น 0 !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    },
  },
  computed: {
    total_cost() {
      let data_list = this.data_list
      let result = data_list.reduce((sum, number) => {
        let set_number = parseFloat(number.cost)
        if (set_number < 0) {
          return sum+(0)
        }
        else {
          return sum+(set_number)
        }
      }, 0)
      return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    total_set() {
      let data_list = this.data_list
      let result = data_list.reduce((sum, number) => {
        let set_number = parseInt(number.quantity_per_sell)
        if (set_number < 0) {
          return sum+(0)
        }
        else {
          return sum+(set_number)
        }
      }, 0)
      return result
    },
  },
  mounted() {
    this.get_date()
    this.get_data()
  }
}
</script>

<style scoped>
.grid_half {
  display: grid;
  grid-template-columns: 30% 70%;
}
.grid_list {
  display: grid;
  grid-template-columns: 50% 50%;
}
@media only screen and (max-width: 1100px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
}
@media only screen and (max-width: 600px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }
  .grid_list {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
}
</style>
